import styled from '@emotion/styled';
import { Col, Row } from 'antd';
import CardIcon from './Icons/CardIcon';
import ShieldIcon from './Icons/ShieldIcon';
import FileCheckIcon from './Icons/FileCheckIcon';



export const InformationBlock = () => {

  return (
    <InformationBlockWrapper>
      <img
        src="https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/694e3694f396fd3ddb478dde_pattern_bismillah_bg.svg"
        loading="lazy"
        alt=""
        className="pattern bismillah"
      />
      <Row gutter={[0, 0]}>
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 10, offset: 0 }}
          lg={{ span: 10, offset: 0 }}
          xl={{ span: 10, offset: 0 }}
        >
          <ItemImage>
            <img
              src="/projectItem.png"
              alt=" Verrichte deine Sadaqah in Ruhe mit klarer Absicht und unter sicherem
        Schutz."
            />
          </ItemImage>
        </Col>

        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 13, offset: 1 }}
          lg={{ span: 13, offset: 1 }}
          xl={{ span: 13, offset: 1 }}
        >
          <RightContent>
            <Title>
              Verrichte deine Sadaqah mit klarer Absicht und unter sicherem
              Schutz.
            </Title>
            <Description>
              commonsplace ist dein deutsch-muslimischer Ort für Sadaqah –
              geschützt durch Technik und getragen von unserer Community.
            </Description>

            <PointsWrapper>
              <PointItem>
                <PointItemItemIcon>
                  <CardIcon />
                </PointItemItemIcon>
                <PointItemContent>
                  <PointItemTitle>Sichere Zahlungsmethoden</PointItemTitle>
                  <PointItemDescription>
                    PayPal, Kreditkarte, Klarna uvm. – alles verschlüsselt und
                    zuverlässig.
                  </PointItemDescription>
                </PointItemContent>
              </PointItem>

              <PointItem>
                <PointItemItemIcon>
                  <ShieldIcon />
                </PointItemItemIcon>
                <PointItemContent>
                  <PointItemTitle>Datenschutzkonform</PointItemTitle>
                  <PointItemDescription>
                    Deine Daten bleiben geschützt und privat. Wir geben eure
                    Daten niemals an Dritte weiter und behalten Sie nur so lange
                    wie nötig.
                  </PointItemDescription>
                </PointItemContent>
              </PointItem>

              <PointItem>
                <PointItemItemIcon>
                  <FileCheckIcon />
                </PointItemItemIcon>
                <PointItemContent>
                  <PointItemTitle>Gemeinsam geprüft</PointItemTitle>
                  <PointItemDescription>
                    Unsere Admins prüfen Projekte, und die Community achtet mit
                    – so bleibt Unterstützung fair und Missbrauch chancenlos.
                    Gelder bleiben bis zur Auszahlung sicher treuhänderisch
                    verwahrt.
                  </PointItemDescription>
                </PointItemContent>
              </PointItem>
            </PointsWrapper>

            <BottomText>
              Weitere Informationen unter{' '}
              <a href="/transparency-and-trust">Transparenz & Vertrauen</a>
            </BottomText>
          </RightContent>
        </Col>
      </Row>
    </InformationBlockWrapper>
  );


}

const InformationBlockWrapper = styled.div`
  background: #f5fbee;
  border-radius: 16px;
  padding: 32px;
  gap: 13px;
  margin-top: 32px;
  position: relative;
  .pattern {
    position: absolute;

    left: 50%;

    transform: translateX(-50%);

    width: 98vw;

    max-width: none;

    top: 0;
    z-index: -1;
    overflow: hidden;
    height: 100%;
    @media (max-width: 768px) {
      width: 95vw;
    }
  
  }
`;

const ItemImage = styled.div`
  width: 100%;
  height: 100%;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const RightContent = styled.div`
  width: 100%;
  gap:13px;
`

const BottomText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  font-family: Inter, sans-serif;
  letter-spacing: 0%;
  
color:#2B4212; 
  a {
    text-decoration: #3F621A underline;
    color: #3F621A
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    color: #2b4212;
  }
`;

const Title = styled.h1`
  /* Heading */
  
  /* Display sm/Semibold */
  font-family: 'Inter',sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  /* or 133% */

  color: #2b4212;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom:4px;
  
  @media (max-width: 768px) {
    text-align: center;
    font-size:16px;
    line-height: 24px;
  }
`;
const Description = styled.p`
  font-family: 'Inter',sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  margin-bottom:24px;

  color: #2b4212;
  
  @media (max-width: 768px) {
    text-align: center;
    font-size:14px;
    line-height: 20px;
  }
`;

const PointsWrapper = styled.div`
  gap: 24px;
  width: 100%;
`
const PointItem = styled.div`
  display: flex;
  gap: 12px;
`

const PointItemItemIcon = styled.div`
  
  width: 48px;
  height: 48px;
  background: #e6f4d7;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 12px;
  svg {
    width: 24px;
    height: 24px;
  }

`;
const PointItemContent = styled.div`
  display: flex;
  flex-direction: column;
`
const PointItemTitle = styled.p`
  margin: 0;
  font-family: 'Inter',sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
  
  @media (max-width: 768px) {
    font-size:16px;
    line-height: 24px;
  }
`;
const PointItemDescription = styled.p`

  font-family: 'Inter',sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 24px;

  color: #535862;
  
  @media (max-width: 768px) {
    font-size:14px;
    line-height: 20px;
  }
  
`;